import { render, staticRenderFns } from "./AdditionalFieldsPage.vue?vue&type=template&id=2440ac8c"
import script from "./AdditionalFieldsPage.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports